(function ($) {
  'use strict';

  /* Certificate viewer for includes/certifications.php: click a card to open
     the certificate image in a modal. */
  $(function () {
    var $modal = $('#pd-cert-modal');
    if (!$modal.length) return;

    var $title = $modal.find('.js-cert-title');
    var $sub = $modal.find('.js-cert-sub');
    var $img = $modal.find('.js-cert-img');

    function close() { $modal.removeClass('open'); }

    $('.pd-cert-card').on('click', function () {
      var $card = $(this);
      $title.text($card.data('name'));
      $sub.text($card.data('sub'));
      $img.attr('src', $card.data('img')).attr('alt', $card.data('name'));
      $modal.addClass('open');
    });
    $modal.on('click', function (e) {
      if (e.target === this) close();
    });
    $modal.find('.pd-cert-modal__close').on('click', close);
    $(document).on('keydown', function (e) {
      if (e.key === 'Escape') close();
    });
  });
})(jQuery);
